<lui-dialog-container>
  <lui-dialog-header>
    <div class="mat-h3">{{ heading }}</div>
  </lui-dialog-header>
  <lui-dialog-content>
    <ng-container *ngIf="contentTemplate; else stringTemplate">
      <ng-container
        [ngTemplateOutlet]="contentTemplate"
        [ngTemplateOutletContext]="{ $implicit: contentTemplateContext }"
      >
      </ng-container>
    </ng-container>

    <ng-template #stringTemplate>
      {{ contentString }}
    </ng-template>
  </lui-dialog-content>
  <lui-dialog-actions align="end">
    <button luiButton matDialogClose cdkFocusInitial>{{ buttonLabel }}</button>
  </lui-dialog-actions>
</lui-dialog-container>
